var _a;
import { __assign } from "tslib";
/* istanbul ignore file */
import { createTheme } from '@mui/material/styles';
import { blue, pink, green, amber } from '@mui/material/colors';
import { ThemeModes } from './variables';
var commonPalette = {
    primary: {
        main: blue[600]
    },
    secondary: {
        main: pink[600]
    },
    success: {
        main: green[600]
    },
    warning: {
        main: amber[700]
    }
};
var palettes = (_a = {},
    _a[ThemeModes.Light] = {
        body: {
            backgroundColor: '#fafafa'
        },
        muiPaperRoot: {
            backgroundColor: '#fff'
        }
    },
    _a[ThemeModes.Dark] = {
        body: {
            backgroundColor: '#303030'
        },
        muiPaperRoot: {
            backgroundColor: '#424242'
        }
    },
    _a);
var theme = function (mode) {
    if (mode === void 0) { mode = ThemeModes.Light; }
    return createTheme(__assign({ palette: __assign({ mode: mode }, commonPalette) }, palettes[mode]));
};
export default theme;
//# sourceMappingURL=theme.js.map